<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page template-padding container" v-else-if="loaded" >
        
        <div class="row" v-if="!data.billing && setup == false" >
            
            <div class="col-12 col-md-6 offset-md-3 text-center mt-5" > <img src="@/assets/images/billing.png" class="w-100" /> </div>
            
            <div class="col-12 text-center" >
                <h2 class="graymedium-color font-900 mt-2" > No billing account set up yet </h2>
            
                <div class='mt-5 mb-3 d-none' style="font-size: 14px;" >
                    <p class="mt-2" > 
                        Create a billing account by clicking the button below.
                        <br><br>
                        <button class="btn btn-primary btn-lg border-radius" @click="setup = true" > Start Billing </button>
                    </p>                    
                </div>
            </div>

        </div>
        
        <div class="row" v-else-if="products.length > 0 && setup == true" >
    
            <!-- TOP CENTER -->
            <div class="col-12" >
                    
                <div class="row " >

                    <div class="col-12 text-center" v-if="products.length > 0" >

                        <div class="col-12 text-center mt-3 d-none" > <h4 class="graymedium-color font-900 mt-2" > Choose a plan </h4> </div>

                        <div class="row pricing mt-5" >

                            <!-- v-if="product.prices[0].recurring.trial_period_days == null" -->
                            <div class="col-25 pricing-col text-center cursor-pointer p-1"  v-for="(product, index) in products" @click="if( selectedProduct.id == product.id ){  }else{ selectedProduct = product }" >
                                
                                <div class="border-gray pt-3 pb-3 border-radius " v-bind:class="{'bg-color-graylight border-main': selectedProduct.id == product.id }" >
                                     
                                    <h5 class="graymedium-color mt-2" > {{ product.name }} </h5>

                                    <h1 class="font-700 main-color mt-4" style="font-size: 2.5rem" > 
                                        {{ product.prices[0].unit_amount / 100 }}€<span class="h4 font-300" > /{{ product.prices[0].recurring.interval }} </span> 
                                    </h1>

                                    <div class='mt-3' style="font-size: 15px;" >
                                        <p class="graymedium-color mt-2" v-if="product.description" > {{ product.description.split(':')[0] }} </p>
                                        <p class="graymedium-color mt-0" v-if="product.description" > <b>{{ product.description.split(':')[1] }}</b> </p>
                                    </div>

                                    <div class='mt-3 mb-3 ' style="font-size: 14px;" >
                                        <p class="graymedium-color mt-2 " > <b> All features included </b> </p>
                                        <p class="graymedium-color mt-2 d-none" > *Refund guarantee: <b> 100%, anytime </b> </p>
                                        <p class="graymedium-color mt-0" > <a href="https://theatlass.com/terms-of-service.html" target="_blank" class="inline-link" >Terms of Service</a> </p>
                                    </div>

                                    <div class='mt-2 ' style="font-size: 16px;" >
                                        <!--
                                        <h4 class="graymedium-color font-900 mt-2 h3" v-if="selectedProduct != product.id" > Select </h4> 
                                        <h4 class="graymedium-color font-900 mt-2 h2 d-none" v-else-if="selectedProduct == product.id" > Selected </h4> 
                                        -->
                                        <button class="btn w-100 border-radius " v-if="selectedProduct.id != product.id"  > Select </button>
                                        <button class="btn w-100 border-radius " v-if="selectedProduct.id == product.id"  > Selected </button>

                                    </div>

                                </div>
                                
                            </div>

                        </div>
                        
                        <div class="col-12 text-center mt-5" > 
                            
                            <button class="btn btn-primary border-radius btn-lg" v-if="!data.billing && selectedProduct.id" @click="setupBilling()" > Start subscription </button>
                            <button class="btn btn-primary border-radius btn-lg" v-else-if="data.billing && selectedProduct.id" @click="startSubscription()" > Start subscription </button>

                            <div class="col-12 mt-3 mb-3" v-if="selectedProduct.id" style="font-size: 14px;" >
                                <input type="checkbox" class="form-control d-inline w-auto m-0 " style="height: auto;" name="legalcheckbox" required :value="legalCheckbox" :checked="legalCheckbox" @input="legalCheckbox = !legalCheckbox"> 
                                I declare that I read and agree to Atlass <a href="https://theatlass.com/terms-of-service.html" target="_blank" class="inline-link" >Terms of Service</a> & <a class="inline-link" href="https://theatlass.com/terms-of-service.html" target="_blank" >Privacy Policy</a>
                            </div>
                            
                            <button class="btn btn-outline-secondary border-radius mt-3" @click="setup = false" > Cancel </button> 
    
                        </div>
                        
                    </div>

                </div>
                    
            </div>
            <!-- TOP CENTER -->
            
        </div>
        
        <div class="row" v-else-if="data.billing && data.billing.customer && setup == false" >

            <!-- LEFT -->
            <div class="col-12 col-md-4 mt-3" >
                
                <div class="col-12 bg-color-graylighter p-4 border-radius" v-if="data.billing.customer.payment_methods.length == 0" >
                    
                    <div class="row " >
                        <div class="col-auto" > <h4 class="graymedium-color font-900 mt-2" > Payment details </h4> </div>
                        <div class="col text-right" > <a @click="manageBilling( data.billing.customer.id )" class="float-right cursor-pointer mt-2" > Add </a>  </div>
                        <div class="col-12 mt-5 text-center" >
                            <div class="text-center" > <font-awesome-icon :icon="['fa', 'credit-card']" class="font-size-20" /> </div>
                            <div class="text-center mt-2" > No payment methods </div>
                        </div>
                    </div>
                    
                </div>
                
                <div class="col-12 bg-color-graylighter p-4 border-radius" v-if="data.billing.customer.payment_methods.length > 0"  >
                    
                    <div class="row " >
                        <div class="col-auto" > <h4 class="graymedium-color font-900 mt-2" > Payment details </h4> </div>
                        <div class="col text-right" > <a @click="manageBilling( data.billing.customer.id )" class="float-right cursor-pointer mt-2" > Edit </a>  </div>
                        
                        <!--
                        <div class="col-12 ml-1 mt-3" v-for="( cc, index ) in data.billing.customer.payment_methods" v-if="cc.id == data.billing.customer.invoice_settings.default_payment_method" >
                        -->
                        <div class="col-12 ml-1 mt-3" v-for="( cc, index ) in data.billing.customer.payment_methods"  >
                            <div class="row" >
                                <div class="col-auto" > <font-awesome-icon :icon="['fa', 'credit-card']" class="font-size-20" /> </div>
                                <div class="col" >
                                    <div class="font-size-16" > **** **** **** {{ cc.card.last4 }} </div>
                                    <div class="font-size-14" > <span class="text-uppercase" > {{ cc.card.brand }} </span> - Expires {{ cc.card.exp_month }}/{{ cc.card.exp_year }} </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12 ml-1 mt-3" v-if="data.billing.subscription.length > 0" >
                            Next billing on: {{ formatDate( data.billing.subscription[0].current_period_end ) }} 
                        </div>
                        
                    </div>
                    
                </div>
                
            </div>
            <!-- LEFT -->
            
            <!-- RIGHT -->
            <div class="col-12 col-md-8 mt-3" >
    
                <div class="col-12 p-4 border-radius border-gray"  >
                    
                    <div class="row " >
                        
                        <div class="col-12" >
                            <div class="row" >
                                <div class="col-auto" > <h4 class="graymedium-color font-900 mt-2" > Subscription details </h4> </div>
                                <div class="col text-right" > 
                                    <a @click="addSubscription()" v-if="data.billing.subscription.length == 0 && data.billing.customer.invoice_settings.default_payment_method != null" class="cursor-pointer mt-2" > Add </a>  
                                    <a @click="manageBilling( data.billing.customer.id )" v-if="data.billing.subscription.length > 0" class="btn btn-primary btn-sm cursor-pointer" > Update </a>  
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12 mt-3 text-center" v-if="data.billing.subscription.length == 0" >
                            <div class="text-center" > <font-awesome-icon :icon="['fa', 'credit-card']" class="font-size-20" /> </div>
                            <div class="text-center mt-2" > No active subscriptions </div>
                        </div>
                        
                        <div class="col-12 mt-4" v-if="data.billing.subscription.length > 0" >
                            <div class="row" v-for="(subscription, index) in data.billing.subscription"  >
                                <div class="col" >
                                    <h3 class="h2 font-900 mt-2" > {{ subscription.subscription_product.name }} </h3> 
                                    <div class="font-size-14 Text-color--graylmedium" > {{ subscription.subscription_product.description }}  </div>
                                    <div class="font-size-14 Text-color--graylmedium" > <a href="https://theatlass.com/pricing.html" target="_blank" rel="noreferrer" > See pricing plans </a>  </div>
                                </div>
                                
                                <div class="col text-right" >
                                    <h2 class="h2 font-900 mt-2" > 
                                        <span class="badge badge-secondary h6 p-1 mr-2" v-if="subscription.cancel_at_period_end" > canceled </span>
                                        <span class="badge badge-secondary h6 p-1 mr-2" v-else-if="!subscription.cancel_at_period_end" > {{ subscription.status }} </span>
                                        {{ subscription.plan.amount / 100 }}€<span class="h5 font-400" > /{{ subscription.plan.interval }} </span> 
                                    </h2> 
                                    
                                    <div class="font-size-14 Text-color--graylmedium" v-if="subscription.cancel_at_period_end" > Subscription will be canceled on {{ formatDate( data.billing.subscription[0].cancel_at ) }}  </div>
                                    
                                    <div class="font-size-14 Text-color--graylmedium" v-else-if="!subscription.cancel_at_period_end" > Next billing on: {{ formatDate( data.billing.subscription[0].current_period_end ) }}  </div>
                                    <div class="font-size-14 Text-color--graylmedium" v-else-if="!subscription.cancel_at_period_end" > Next billing on: {{ formatDate( data.billing.subscription[0].current_period_end ) }}  </div>

                                    <div class="font-size-14 Text-color--graylmedium" v-else-if="!subscription.cancel_at_period_end && subscription.trial_end != null" > Trial ends at: {{ formatDate( subscription.trial_end ) }}  </div>
                                    <div class="font-size-14 Text-color--graylmedium" v-else-if="!subscription.cancel_at_period_end && subscription.trial_end == null && subscription.start_date != null" > Started at: {{ formatDate( subscription.start_date ) }}  </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                
            </div>
            <!-- RIGHT -->
            
            <div class="col-12 text-center mt-5" >
                
                <div class="col-12 col-md-4 offset-md-4 text-center" > <img src="@/assets/images/billing.png" class="w-100" /> </div>
                
                <h2 class="graymedium-color font-900 mt-2" > Manage billing </h2>
            
                <div class='mt-3 mb-3' style="font-size: 16px;" >
                    <p class="mt-2" > 
                        You will be redirected to our customer portal
                    </p>
                </div>
                
                <button v-if="data.billing.customer.id" class="btn btn-primary border-radius" @click="manageBilling( data.billing.customer.id )" > Go </button>
                
            </div>

        </div>
        
        <!--
        <div class="row pricing mt-5" >
            
            <div class="col text-center border-gray pt-5 pb-5" >
                <h5 class="graymedium-color mt-2" > STARTER </h5>
                
                <h1 class="font-700 main-color mt-5" style="font-size: 3.2rem" > 99€<span class="h4 font-300" > /month </span> </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4" >  </span>  -  </h2>
                
                <h6 class="graymedium-color font-900 mt-5 " > .6% max cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 0 - 15k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 0 </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 15,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
            <div class="col text-center border-gray pt-5 pb-5" >
                <h5 class="graymedium-color mt-2" > INTERMEDIATE </h5>
                
                <h1 class="font-700 main-color mt-5" style="font-size: 3.2rem" > 199€<span class="h4 font-300" > /month </span> </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4" > or </span> 499€<span class="h4 font-300" > /3 months </span> </h2>
                
                <h6 class="graymedium-color font-900 mt-5 " > 1.4% - .6% tracked cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 15k - 25k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 15,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 25,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
            <div class="col text-center border-gray pt-5 pb-5" >
                <h5 class="graymedium-color mt-2" > ADVANCED </h5>
                
                <h1 class="font-700 main-color mt-5" style="font-size: 3.2rem" > 349€<span class="h4 font-300" > /month </span> </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4 " > or </span> 899€<span class="h4 font-300" > /3 months </span> </h2>
                
                <h6 class="graymedium-color font-900 mt-5 " > 1.4% - .6% tracked cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 25k - 50k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 25,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 50,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
            <div class="col text-center border-gray pt-5 pb-5" >
                <h5 class="graymedium-color mt-2" > PROFFESIONAL </h5>
                
                <h1 class="font-700 main-color mt-5" style="font-size: 3.2rem" > 499€<span class="h4 font-300" > /month </span> </h1>
                <h2 class="font-700 graymedium-color mt-2" > <span class="graymedium-color font-500 h4" > or </span> 1249€<span class="h4 font-300" > /3 months </span> </h2>
                
                <h6 class="graymedium-color font-900 mt-5 " > 1% - .6% tracked cap </h6>
                
                <div class='mb-3' style="font-size: 14px;" >
                    <p class="graymedium-color mt-2" > Tracked income:  <b> 50k - 75k€ </b> </p>
                    <p class="graymedium-color mt-1 " > Minimum tracked cap: <b> 50,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Maximum tracked cap: <b> 75,000€ </b> </p>
                    <p class="graymedium-color mt-1 " > Features: <b> all features included </b> </p>
                    
                    <p class="graymedium-color mt-5 " > *Refund guarantee: <b> 100%, anytime </b> </p>
                </div>
            </div>
            
        </div>
        -->
        
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';
import axios from 'axios'
import jwt_decode from "jwt-decode";
    
import billingSetup from '@/components/billingSetup.vue'    

export default {
    name: 'Pricing',
    components:{
        billingSetup
    },
    props: {
    },
    data: function(){
        return {
            loaded: false,
            data:{
                billing:false
            },
            legalCheckbox: false,
            products: [],
            selectedProduct: {},
            
            setup: false
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        //this.get_data();
        
        //let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
        //this.data.organizationID = orgID;
        
        this.getStripeCustomer()
        //setTimeout(function(){ this.loaded = true }.bind(this), 100 );
        
    },
    beforeDestroy() {
    },
    methods: {
        
        setupBilling(  ){

            if( !this.legalCheckbox ){
                
                this.$toast.error({
                    title: 'Legal consent required',
                    message:  'Please make sure to read and agree with the terms of service and privacy policy'
                })
                
            }else{
                let user =  Cookies.get('user')
                user = JSON.parse( atob( user ) )
                //console.log( user )

                let customer = {
                    email: user.email,
                    name: user.firstname + " " + user.lastname,
                    created_at: user.datetime
                }

                let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', 'X_AUTH_TOKEN': Cookies.get('user-token') }

                return axios({ 
                    method: 'post',
                    url: process.env.ROOT_API+'/create-customer',
                    headers: headers,
                    data: {
                        "customer": customer,
                        "product": this.selectedProduct,
                    }
                })
                .then(resp => {    
                    //console.log(resp.data)
                    let data = resp.data

                    if( data.subscription.length > 0 ){

                        data.subscription.forEach((sub)=>{
                            let product = this.products.filter(function(o){return o.id == sub.plan.product })[0]
                            sub.subscription_product = product
                            //console.log(sub)
                        })

                    }

                    //console.log(data)

                    this.data.billing = data
                    this.setup = false

                    if( this.data.billing.customer.payment_methods.length == 0 ){
                        this.$toast.success({
                            title: 'Billing started',
                            message:  'Please fill out the payment and billing details'
                        })

                        setTimeout(function(){ this.manageBilling( resp.data.customer.id ) }.bind(this), 2000 );
                    }

                })
                .catch(error => {
                    console.log(error)
                }); //end axios 
            }
                
            
        },
        
        manageBilling( STRIPE_customerID ){

            this.$toast.success({
                title: 'Info',
                message:  'You will be redirected to our secure customer portal'
            })
            
            let params = Cookies.get('user-token');
            let headers = { 
                'Content-Type': 'application/json;charset=utf-8', 
                'Access-Control-Allow-Headers': "*",  
                'Access-Control-Allow-Origin': "*",  
                'Access-Control-Allow-Credentials': "true",  
                "X-Auth": params 
            };
            
            let payload = { 
                    'customer': STRIPE_customerID,
                    'return_url': process.env.ROOT_DOMAIN+'/app/settings/billing'
                    //'return_url': 'http://localhost:3002/app/settings/billing'
                } 
            
            return axios({ 
                method: 'post',
                url: process.env.ROOT_API+'/api/account/create-customer-portal-session.php',
                headers: headers,
                data: btoa( JSON.stringify( payload ) )
            })
            .then(resp => {    
                console.log(resp.data)
                
                let url = resp.data.data
                window.location.replace( url );
                
            })
            .catch(error => {
                console.log(error)
            }); //end axios 
            
        },
        
        getStripeCustomer(  ){
            
            let params = Cookies.get('user-token');
            let headers = { 
                'Content-Type': 'application/json;charset=utf-8', 
                'Access-Control-Allow-Headers': "*",  
                'Access-Control-Allow-Origin': "*",  
                'Access-Control-Allow-Credentials': "true",  
                "X-Auth": params 
            };
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/api/account/billing.php', headers: headers })
            .then(resp => {
                //console.log(resp)
                let r = resp.data;
                
                if( resp.status != 200 || r.status != 200 ){

                    

                }else{
                    
                    //this.user = resp.data.data[0]
                    this.data.billing = resp.data.data
                    this.loaded = true
                    
                }

            })
            
            /*
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log( user )
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', 'X_AUTH_TOKEN': Cookies.get('user-token') }
            
            return axios({ 
                method: 'post',
                url: process.env.ROOT_API+'/account/billing.php',
                headers: headers,
                data: { 
                    "email": user.email,
                } 
            })
            .then(resp => {    
                let data = resp.data
                if( data != false ){
                    if( data.subscription.length > 0 ){

                        data.subscription.forEach((sub)=>{
                            let product = this.products.filter(function(o){return o.id == sub.plan.product  })[0]
                            sub.subscription_product = product
                            //console.log(sub)
                        })

                    }
                    this.data.billing = data
                }
                this.loaded = true
                //console.log(this.data)
            })
            .catch(error => {
                console.log(error)
                //log out
            }); //end axios 
            */
            
        },
        
        getStripeProducts(  ){
            
            return axios({ 
                method: 'post',
                url: process.env.ROOT_API+'/billing/products',
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;',
                    'X_AUTH_TOKEN': Cookies.get('user-token')
                }
            })
            .then(resp => {
                console.log(resp)
                if( resp.data.status == 103 ){
                    //window.location.reload()
                    
                    this.$swal({
                        title: 'Refresh required',
                        text: 'Please reload the page in order to refresh the session token ',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, refresh'
                    }).then((result) => {
                        if (result.value) { 
                            window.location.reload()
                        }
                    })
                    
                }
                else{
                    resp.data.forEach((product)=>{
                        if( product.prices[0].recurring && product.prices[0].recurring.trial_period_days == null ){
                            this.products.push( product )
                        }
                    })
                    this.products.sort((a, b) => a.prices[0].unit_amount - b.prices[0].unit_amount)
                    //this.products = resp.data
                    //console.log(this.products)
                    this.getStripeCustomer()
                } 
                    
            })
            .catch(error => {
                console.log(error)
            }); //end axios 
            
        },
        
        addSubscription(  ){
            if( this.products.length > 0 ){ this.setup = true }
            else{
                this.$toast.success({
                    title: 'Error',
                    message:  'No subscriptions to choose from'
                })
            }
        },
        
        startSubscription(  ){
            
            if( !this.legalCheckbox ){
                
                this.$toast.error({
                    title: 'Legal consent required',
                    message:  'Please make sure to read and agree with the terms of service and privacy policy'
                })
                
            }else{
                this.$toast.success({
                    title: 'Info',
                    message:  'Setting up biling account and subscription'
                })

                let user =  Cookies.get('user')
                user = JSON.parse( atob( user ) )
                //console.log( user )

                let customer = {
                    email: user.email,
                    name: user.firstname + " " + user.lastname,
                    created_at: user.datetime
                }

                let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', 'X_AUTH_TOKEN': Cookies.get('user-token') }

                return axios({ 
                    method: 'post',
                    url: process.env.ROOT_API+'/billing/start-subscription',
                    headers: headers,
                    data:{
                        "product": this.selectedProduct,
                        "customer": this.data.billing.customer,
                        "user": customer
                    }
                })
                .then(resp => {    
                    //console.log( resp.data )
                    if( resp.data ){
                        this.$toast.success({
                            title: 'Info',
                            message:  'Subscription created'
                        })

                        let sub = resp.data

                        let product = this.products.filter(function(o){return o.id == sub.plan.product  })[0]
                        sub.subscription_product = product

                        this.setup = false
                        this.data.billing.subscription.push( sub )
                        console.log(this.data.billing)

                    }
                })
                .catch(error => {
                    console.log(error)
                }); //end axios 

            }
            
                
        },
        
        get_data(){

            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log( user )

            const db = firebase.firestore();
            var ref = db.collection('users').doc( user.userID )

            return ref.get()
                .then((snapshot) => {
                    console.log(snapshot.data())
                    this.data = snapshot.data()
                    this.data.id = snapshot.id
                    this.loaded = true;
                })

        },
        formatDate(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        routePrimaryLead(ID){
            this.$router.push({
                name: 'LeadPage',
                params: { ID: ID }
            });
        },
        submit(){
            console.log( this.data )
        },
        copyScript(){

            var range = document.createRange();
            range.selectNode(document.getElementById("script"));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect

            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })

        }
    },
    computed: {
        userRole(){
            return this.$store.getters.getRole
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .pricing .col{
        margin-left: 5px;
    }
    .pricing .col:first-of-type{
        margin-left: 0;
    }
    
</style>



// WEBPACK FOOTER //
// src/templates/settings/Billing.vue